import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {AnyToDo} from '../../../typings/todo';
import {ENTITY_TYPES} from '../../services/albumProvider/albumProviderConstant';
import {Title} from '../ui/Title';

export const GetTitle: React.FunctionComponent<AnyToDo> = (props) => {
  const {entityType, ...otherProps} = props;
  const {t} = useTranslation();
  const titlesMap = {
    [ENTITY_TYPES.ALBUM]: 'mgw.getAlbum',
    [ENTITY_TYPES.SINGLE]: 'mgw.getSingle',
    [ENTITY_TYPES.TRACK]: 'mgw.getTrack',
  };
  const titleKey = titlesMap[entityType];
  return <Title {...otherProps}>{t(titleKey)}</Title>;
};

GetTitle.propTypes = {
  t: PropTypes.func,
  entityType: PropTypes.string.isRequired,
};
